module.exports = __webpack_public_path__ + "static/img/default.6dbce0af.jpg";